// extracted by mini-css-extract-plugin
export default {"speakers":"ForumSpeakers_speakers__7neMM","center":"ForumSpeakers_center__jv6Ol"};